import { useSyncExternalStore } from 'react';
import {
  isCarouselSoundEnabled,
  setCarouselSoundEnabled,
  subscribeCarouselSound,
} from '@/lib/carousel-sound';

/** Reactive view of the carousel's global sound preference. */
export function useCarouselSound() {
  const enabled = useSyncExternalStore(
    subscribeCarouselSound,
    isCarouselSoundEnabled,
    () => true
  );

  return { enabled, setEnabled: setCarouselSoundEnabled };
}
